import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateOnboardingSearch } from './lib/onboardingSearch';

/**
 * One route, with the selected onboarding and the active tab as search params.
 *
 * `/onboarding?id=…&tab=documents` rather than `/onboarding/:id/documents`
 * because all five tabs render from a single request for a single record — five
 * child routes would each load the same query and differ only in which slice
 * they show. The URL still carries the full view state, which is the property
 * that matters.
 */
export const onboardingRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/onboarding',
  component: lazyRouteComponent(() => import('./pages/OnboardingPage'), 'OnboardingPage'),
  validateSearch: validateOnboardingSearch,
});

export const onboardingRoutes = [onboardingRoute];
